import React, { useState, useEffect } from 'react';

import {
    TextField,
    Checkbox,
    Button,
    FormControlLabel,
    Link,
    Box,
    InputLabel,
    Dialog,
    DialogContent,
    DialogTitle,
    InputAdornment,
    IconButton,
    Alert,
    CircularProgress,
    useMediaQuery,
    Typography,
    Snackbar
} from '@mui/material';
import { Visibility, VisibilityOff, Email, Lock } from '@mui/icons-material';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import baseUrl from '../slices/baseUrl';
import { GlobalStyles } from '@mui/system';
import {
    userLogin,
    getAllRoles,
    getUserAccess,
    loginStatus
} from '../slices/loginSlice';
import { useTheme } from '@mui/material/styles';
import PublicLayout from '../Layout/PublicLayout';
import PremiumCard from '../components/common/PremiumCard';

const pathBySrno = [
    { srno: 1, to: '/dashboard' },
    { srno: 2, to: 'viewersList' },
    { srno: 3, to: 'advertiserList' },
    { srno: 4, to: 'adApprovalList' },
    { srno: 5, to: 'accessManagement' },
    { srno: 7, to: 'refundRequests' },
    { srno: 8, to: 'support' }
];

const LogInForm = props => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [email, setEmail] = useState('');
    const [emailToPwdReset, setEmailToPwdReset] = useState('');
    const [password, setPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [otpValue, setOtpValue] = useState('');
    const [rememberAdmMe, setRememberMe] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [errorMsgForgotPwd, setErrorMsgForgotPwd] = useState('');
    const [loginSuccessMessage, setLoginSuccessMessage] = useState('');
    const [loginSuccessOpen, setLoginSuccessOpen] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [loading, setLoading] = useState(false);
    const theme = useTheme();
    const isSmallScreen = useMediaQuery('(max-width:600px)');

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');

    const [otpSent, setOtpSent] = useState(false);
    const [otpVerified, setOtpVerified] = useState(false);
    const [allRoles, setAllRoles] = useState([]);

    let user = useSelector(state => state?.emailLogin?.user);
    let error = useSelector(state => state?.emailLogin?.error);
    let allrolesResult = useSelector(state => state?.emailLogin?.allRoles);

    useEffect(() => {
        error = null;
        const rememberedAdmEmail = localStorage?.getItem('rememberedAdmEmail');
        const rememberedAdmPassword = localStorage?.getItem(
            'rememberedAdmPassword'
        );
        const rememberedAdmMe =
            localStorage?.getItem('rememberAdmMe') === 'true';

        if (rememberedAdmMe) {
            setEmail(rememberedAdmEmail || '');
            setPassword(rememberedAdmPassword || '');
            setRememberMe(rememberedAdmMe);
        }
        dispatch(getAllRoles());
    }, []);

    useEffect(() => {
        if (error) {
            setSnackbarMessage(error);
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            return;
        }
    }, [error]);

    useEffect(() => {
        allrolesResult && setAllRoles(allrolesResult);
    }, [allrolesResult]);

    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };

    // login
    const handleLogin = async event => {
        event.preventDefault();
        setLoading(true);

        if (!email) {
            setLoginSuccessOpen(true);
            setSnackbarSeverity('error');
            setLoginSuccessMessage('Please enter email');
            setLoading(false);
        } else if (!password) {
            setLoginSuccessOpen(true);
            setSnackbarSeverity('error');
            setLoginSuccessMessage('Please enter password');
            setLoading(false);
        } else {
            let loginData = {
                email: email,
                password: password
            };

            dispatch(userLogin(loginData))
                .then(response => {
                    if (response?.payload?.role) {
                        dispatch(getUserAccess(response?.payload?.role))
                            .then(result => {
                                let goto = '';

                                result &&
                                    pathBySrno?.map(path => {
                                        if (
                                            result?.payload?.access[0] ===
                                            path?.srno
                                        ) {
                                            goto = path?.to;
                                            return;
                                        }
                                    });

                                allRoles?.map(role => {
                                    if (response?.payload?.role === role) {
                                        sessionStorage.setItem(
                                            'adminAuth',
                                            true
                                        );
                                        dispatch(loginStatus(true));
                                        setLoginSuccessOpen(true);
                                        setSnackbarSeverity('success');
                                        setLoginSuccessMessage(
                                            'Logged in successfully!'
                                        );

                                        if (rememberAdmMe) {
                                            localStorage.setItem(
                                                'rememberedAdmEmail',
                                                email
                                            );
                                            localStorage.setItem(
                                                'rememberedAdmPassword',
                                                password
                                            );
                                            localStorage.setItem(
                                                'rememberAdmMe',
                                                rememberAdmMe
                                            );
                                        } else {
                                            localStorage.removeItem(
                                                'rememberedAdmEmail'
                                            );
                                            localStorage.removeItem(
                                                'rememberedAdmPassword'
                                            );
                                            localStorage.removeItem(
                                                'rememberAdmMe'
                                            );
                                        }

                                        sessionStorage.setItem(
                                            'role',
                                            response?.payload?.role
                                        );
                                        sessionStorage.setItem(
                                            'userId',
                                            response?.payload?.id
                                        );

                                        sessionStorage.setItem(
                                            'email',
                                            response?.payload?.email
                                        );
                                        setTimeout(() => {
                                            setLoginSuccessMessage('');
                                            handleLoginSuccessClose();
                                            navigate(goto);
                                        }, 2000);
                                    } else {
                                        setErrorMsg(response?.error?.message);
                                    }
                                });
                            })
                            .catch({});
                    } else {
                        setSnackbarMessage(response?.payload.response.data.developermsg);
                        setSnackbarSeverity('error');
                        setSnackbarOpen(true);
                    }
                })
                .catch(error => {
                    setErrorMsg(error?.response?.developermsg);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    const handleLoginSuccessClose = () => {
        setLoginSuccessOpen(false);
    };

    const handleErrorClear = () => {
        setErrorMsg(prevValue => (prevValue = ''));
    };

    const handleTogglePasswordVisibility = () => {
        setShowPassword(prevShowPassword => !prevShowPassword);
    };

    // forgot password
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    const handleClickOpen = event => {
        event.preventDefault();
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setTimeout(() => {
            setOtpSent(false);
            setOtpVerified(false);
            setEmailToPwdReset('');
            setNewPassword('');
            setConfirmPassword('');
            setErrorMsgForgotPwd('');
        }, 1000);
        navigate('/');
    };

    const handleEmailChange = e => {
        const emailWithoutSpaces = e.target.value.replace(/\s/g, '');
        setEmailToPwdReset(emailWithoutSpaces);
    };

    const handleSendOTP = async () => {
        setLoading(true);
        if (!emailToPwdReset) {
            setLoginSuccessOpen(true);
            setSnackbarSeverity('error');
            setLoginSuccessMessage('Please enter email');
            setLoading(false);
        } else if (!/^[a-z]/.test(emailToPwdReset)) {
            setLoginSuccessOpen(true);
            setSnackbarSeverity('error');
            setLoginSuccessMessage('Email should start with alphabet only');
            setLoading(false);
        } else {
            const emailPattern = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
            const validEmail = emailPattern.test(emailToPwdReset);
            if (!validEmail) {
                setLoginSuccessOpen(true);
                setSnackbarSeverity('error');
                setLoginSuccessMessage('Please enter valid email');
                setLoading(false);
                return;
            }
            try {
                const response = await axios.post(
                    `${baseUrl}/users/sendOtp?email=${emailToPwdReset}`
                );
                if (response?.status === 200) {
                    setOtpSent(true);
                    setLoginSuccessMessage(response?.data);
                    setSnackbarSeverity('success');
                    setLoginSuccessOpen(true);
                    setTimeout(() => {
                        setEmail('');
                    }, 2000);
                } else {
                    setSnackbarMessage('Oops something went wrong...');
                    setSnackbarSeverity('error');
                    setSnackbarOpen(true);
                }
            } catch (error) {
                setSnackbarMessage(error?.response?.data?.developermsg);
                setSnackbarSeverity('error');
                setSnackbarOpen(true);
            } finally {
                setLoading(false);
            }
        }
    };

    const handleOtpChange = e => {
        const inputValue = e.target.value.trim();
        const numericValue = inputValue.replace(/\D/g, '');
        setOtpValue(numericValue);
    };

    const handleNewPasswordChange = e => {
        setNewPassword(e.target.value.trim());
    };
    const handleConfirmPasswordChange = e => {
        setConfirmPassword(e.target.value.trim());
    };

    const handlePwdErrorClear = () => {
        setErrorMsgForgotPwd(prevValue => (prevValue = ''));
    };
    
    const handleVerifyOTP = async () => {
        if (!otpValue) {
            setLoginSuccessOpen(true);
            setSnackbarSeverity('error');
            setLoginSuccessMessage('Please enter valid OTP');
            setLoading(false);
        } else {
            try {
                const response = await axios.post(
                    `${baseUrl}/users/verifyOtp`,
                    {
                        email: emailToPwdReset,
                        otp: otpValue
                    }
                );
                if (response?.status === 200) {
                    setOtpValue('');
                    setOtpVerified(true);
                    setLoginSuccessMessage(response?.data);
                    setSnackbarSeverity('success');
                    setLoginSuccessOpen(true);
                    setTimeout(() => { }, 2000);
                } else {
                    setSnackbarMessage('Oops something went wrong...');
                    setSnackbarSeverity('error');
                    setSnackbarOpen(true);
                }
            } catch (error) {
                setLoginSuccessMessage(error?.response?.data?.developermsg);
                setSnackbarSeverity('error');
                setLoginSuccessOpen(true);
            } finally {
                setLoading(false);
            }
        }
    };

    const handleResetPassword = async () => {
        setLoading(true);
        const passwordPattern = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*/;

        if (!newPassword) {
            setLoginSuccessOpen(true);
            setSnackbarSeverity('error');
            setLoginSuccessMessage('Please enter new password');
            setLoading(false);
        } else if (!confirmPassword) {
            setLoginSuccessOpen(true);
            setSnackbarSeverity('error');
            setLoginSuccessMessage('Please enter confirm password');
            setLoading(false);
        } else if (newPassword !== confirmPassword) {
            setLoginSuccessOpen(true);
            setSnackbarSeverity('error');
            setLoginSuccessMessage(
                'Password and conform password are not same'
            );
            setLoading(false);
        } else if (newPassword?.length < 8 || newPassword?.length > 15) {
            setLoginSuccessOpen(true);
            setSnackbarSeverity('error');
            setLoginSuccessMessage(
                'Password length must be between 8 and 15 characters'
            );
            setLoading(false);
        } else if (!passwordPattern.test(newPassword)) {
            setLoginSuccessOpen(true);
            setSnackbarSeverity('error');
            setLoginSuccessMessage(
                'Password must contain at least 1 lowercase letter, 1 uppercase letter and 1 digit'
            );
            setLoading(false);
        } else {
            await axios
                .put(`${baseUrl}/users/forgotpassword`, {
                    email: emailToPwdReset,
                    password: newPassword
                })
                .then(response => {
                    if (response?.status === 200) {
                        setEmailToPwdReset('');
                        setNewPassword('');
                        setLoginSuccessOpen(true);
                        setSnackbarSeverity('success');
                        setLoginSuccessMessage(response?.data);
                        setTimeout(() => {
                            handleClose();
                        }, 2000);
                        navigate('/');
                    }
                })
                .catch(error => {
                    setLoginSuccessOpen(true);
                    setSnackbarSeverity('error');
                    setLoginSuccessMessage(error?.response?.data?.developermsg);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    return (
        <PublicLayout>
            <GlobalStyles
                styles={{
                    'input:-webkit-autofill': {
                        WebkitBoxShadow: theme.palette.mode === 'dark' ? '0 0 0px 1000px rgba(150, 150, 150, 0.1) inset !important' : '0 0 0px 1000px rgba(0, 0, 0, 0.05) inset !important',
                        WebkitTextFillColor: `${theme.palette.text.primary} !important`,
                        transition: 'background-color 5000s ease-in-out 0s !important',
                    },
                }}
            />
            
            <PremiumCard
                active={true}
                title="Admin Access"
                subtitle="Welcome Back"
            >
                <form onSubmit={handleLogin} noValidate>
                    <Box sx={{ mb: 3, mt: 1 }}>
                        <Typography variant="body2" color="text.secondary">
                            Enter your credentials to access the admin dashboard.
                        </Typography>
                    </Box>

                    {/* Email Input */}
                    <Box sx={{ mb: 2 }}>
                        <InputLabel sx={{ mb: 1, fontSize: '0.9rem', fontWeight: 500 }}>Email Address</InputLabel>
                        <TextField
                            fullWidth
                            placeholder="name@example.com"
                            value={email}
                            onChange={e => setEmail(e.target.value.trim())}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.2)' : 'rgba(255,255,255,0.5)',
                                    borderRadius: '12px',
                                }
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Email sx={{ color: 'text.secondary', opacity: 0.7 }} />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>

                    {/* Password Input */}
                    <Box sx={{ mb: 2 }}>
                        <InputLabel sx={{ mb: 1, fontSize: '0.9rem', fontWeight: 500 }}>Password</InputLabel>
                        <TextField
                            fullWidth
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Enter your password"
                            value={password}
                            onChange={e => setPassword(e.target.value.trim())}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.2)' : 'rgba(255,255,255,0.5)',
                                    borderRadius: '12px',
                                }
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Lock sx={{ color: 'text.secondary', opacity: 0.7 }} />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={handleTogglePasswordVisibility}
                                            edge="end"
                                        >
                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={rememberAdmMe}
                                    onChange={e => setRememberMe(e.target.checked)}
                                    color="primary"
                                    sx={{ '& .MuiSvgIcon-root': { borderRadius: '6px' } }}
                                />
                            }
                            label={<Typography variant="body2">Remember me</Typography>}
                        />
                        <Link
                            component="button"
                            variant="body2"
                            onClick={handleClickOpen}
                            sx={{ fontWeight: 500, textDecoration: 'none', color: 'primary.main', '&:hover': { textDecoration: 'underline' } }}
                        >
                            Forgot password?
                        </Link>
                    </Box>

                    {errorMsg && (
                        <Alert severity="error" sx={{ mb: 2, borderRadius: '8px' }}>
                            {errorMsg}
                        </Alert>
                    )}

                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        disabled={loading}
                        sx={{
                            py: 1.5,
                            borderRadius: '12px',
                            fontWeight: 600,
                            fontSize: '1rem',
                            textTransform: 'none',
                            position: 'relative',
                            overflow: 'hidden',
                            background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                            boxShadow: `0 8px 16px -4px ${theme.palette.primary.main}66`,
                            '&:hover': {
                                boxShadow: `0 12px 20px -4px ${theme.palette.primary.main}88`,
                            }
                        }}
                    >
                        {loading ? <CircularProgress size={24} color="inherit" /> : 'Sign In'}
                    </Button>

                    <Box sx={{ mt: 3, textAlign: 'center' }}>
                        <Typography variant="body2" color="text.secondary">
                            Don't have an account?{' '}
                            <Link href="/signup" sx={{ fontWeight: 600, textDecoration: 'none', color: 'primary.main' }}>
                                Sign up
                            </Link>
                        </Typography>
                    </Box>
                </form>
            </PremiumCard>

            {/* Success Dialog */}
            <Dialog open={loginSuccessOpen} onClose={handleLoginSuccessClose} PaperProps={{ sx: { borderRadius: '16px' } }}>
                <DialogTitle sx={{ textAlign: 'center', pt: 3 }} id="alert-dialog-title">
                    {snackbarSeverity === 'success' ? 'Success!' : 'Notice'}
                </DialogTitle>
                <DialogContent>
                   <Box sx={{ textAlign: 'center', minWidth: '250px' }}>
                        <Typography>{loginSuccessMessage}</Typography>
                   </Box>
                </DialogContent>
            </Dialog>

            {/* Forgot Password Dialog */}
            <Dialog open={open} onClose={handleClose} PaperProps={{ sx: { borderRadius: '16px', p: 1 } }}>
                <DialogTitle sx={{ fontWeight: 600 }}>Reset Password</DialogTitle>
                <DialogContent>
                    {!otpSent && !otpVerified && (
                        <Box sx={{ mt: 1 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                Enter your email address to receive a verification code.
                            </Typography>
                            <TextField
                                autoFocus
                                margin="dense"
                                label="Email Address"
                                type="email"
                                fullWidth
                                variant="outlined"
                                value={emailToPwdReset}
                                onChange={handleEmailChange}
                                sx={{ mb: 2 }}
                            />
                            <Button variant="contained" fullWidth onClick={handleSendOTP} disabled={loading} sx={{ borderRadius: '8px' }}>
                                {loading ? <CircularProgress size={24} /> : 'Send Code'}
                            </Button>
                        </Box>
                    )}

                    {otpSent && !otpVerified && (
                        <Box sx={{ mt: 1 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                Enter the 4-digit code sent to your email.
                            </Typography>
                            <TextField
                                autoFocus
                                margin="dense"
                                label="OTP Code"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={otpValue}
                                onChange={handleOtpChange}
                                sx={{ mb: 2 }}
                            />
                            <Button variant="contained" fullWidth onClick={handleVerifyOTP} disabled={loading} sx={{ borderRadius: '8px' }}>
                                {loading ? <CircularProgress size={24} /> : 'Verify Code'}
                            </Button>
                        </Box>
                    )}

                    {otpVerified && (
                        <Box sx={{ mt: 1 }}>
                             <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                Create a new password for your account.
                            </Typography>
                            <TextField
                                margin="dense"
                                label="New Password"
                                type="password"
                                fullWidth
                                variant="outlined"
                                value={newPassword}
                                onChange={handleNewPasswordChange}
                                sx={{ mb: 2 }}
                            />
                            <TextField
                                margin="dense"
                                label="Confirm Password"
                                type="password"
                                fullWidth
                                variant="outlined"
                                value={confirmPassword}
                                onChange={handleConfirmPasswordChange}
                                sx={{ mb: 2 }}
                            />
                            <Button variant="contained" fullWidth onClick={handleResetPassword} disabled={loading} sx={{ borderRadius: '8px' }}>
                                {loading ? <CircularProgress size={24} /> : 'Reset Password'}
                            </Button>
                        </Box>
                    )}
                    {errorMsgForgotPwd && <Alert severity="error" sx={{ mt: 2 }}>{errorMsgForgotPwd}</Alert>}
                </DialogContent>
            </Dialog>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%', borderRadius: '8px' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </PublicLayout>
    );
};

export default LogInForm;
